const getGeneralOptions = (graphConstants) => {
  const { xAxisLabel, yAxisLabel, defaultFontFamily, fontColor, tickFontColor } = graphConstants;
  return {
    layout: {
      padding: {
        top: 35,
        left: 200,
        right: 30,
      },
    },
    legend: {
      display: false,
    },
    scales: {
      yAxes: [{
        stacked: true,
        gridLines: {
          color: [
            null,
            'white',
          ],
        },
        display: true,
        scaleLabel: {
          display: true,
          labelString: yAxisLabel,
          fontFamily: defaultFontFamily,
          fontSize: 16,
          fontColor,
        },
        ticks: {
          min: 0,
          max: 100,
          stepSize: 25,
          callback: value => (value === 75 || value === 0 ? '' : `${value}%`),
          fontColor: tickFontColor,
        },
      }],
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          labelString: xAxisLabel,
          fontFamily: defaultFontFamily,
          fontSize: 16,
          fontColor,
        },
      }],
    },
  };
};

export default getGeneralOptions;
